import React, { createContext, useContext, useMemo } from 'react';

const PopoverControlContext = createContext<{
	isOpen: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
} | null>(null);

export function PopoverProvider({
	children,
	setIsOpen,
	isOpen,
}: {
	children: React.ReactNode;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	isOpen: boolean;
}) {
	const contextValue = useMemo(() => ({ isOpen, setIsOpen }), [isOpen]);

	return <PopoverControlContext.Provider value={contextValue}>{children}</PopoverControlContext.Provider>;
}

export function usePopoverControl() {
	return useContext<{ isOpen: boolean; setIsOpen: React.Dispatch<React.SetStateAction<boolean>> } | null>(
		PopoverControlContext,
	);
}
